export default __webpack_public_path__ + "static/media/expertise_xl.2907e87c.jpg";